@use '../../styles/global' as *;
@use '../../styles/kol-alert-mixin' as *;
@use '../../styles/kol-custom-suggestions-option' as *;
@use '../../styles/kol-custom-suggestions-options-group' as *;
@use '../../styles/kol-custom-suggestions-toggle' as *;
@use '../../styles/kol-form-field-mixin' as *;
@use '../../styles/kol-input-container-mixin' as *;
@use '../../styles/kol-input-mixin' as *;
@use '../@shared/mixins' as *;
@use '../@shared/kol-button-mixin' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-custom-suggestions-option;
	@include kol-custom-suggestions-options-group;
	@include kol-custom-suggestions-toggle;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;

	$option-height: to-rem(40);
	$visible-options: var(--visible-options, 5);

	.kol-single-select {
		&__delete {
			@include kol-button-styles('kol-button');
			.kol-button {
				margin-top: -2px;
				margin-bottom: -2px;
			}
		}

		&__no-results-message {
			display: flex;
			min-height: to-rem(50);
			align-items: center;
			justify-content: center;
			cursor: default;
		}

		.kol-custom-suggestions-options-group {
			max-height: calc($option-height * $visible-options + to-rem(2)) !important;
		}
	}

	.kol-custom-suggestions-toggle {
		&:not(&--disabled) {
			cursor: pointer;
		}

		&--disabled {
			opacity: 0.5;
		}
	}
}
